<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon>
        <v-icon @click="$router.go(-1)">mdi-backspace</v-icon>
      </v-btn>

      <v-toolbar-title class="mt-5"
        >{{ course.course_name }}
        <span v-if="allowed"> - Section {{ course.section }} </span>

        <v-btn
          small
          class="white"
          icon
          :href="course.zoom_link"
          target="_blank"
        >
          <v-icon small color="blue darken-2" class="ma-0"> mdi-video </v-icon>
        </v-btn>
        <v-btn
          small
          class="white ml-2"
          icon
          :href="course.google_classroom_link"
          target="_blank"
        >
          <v-icon small color="blue darken-2" class="ma-0">
            mdi-google-classroom
          </v-icon>
        </v-btn>

        <v-spacer />
        <h6 class="mt-4">
          Period: {{ course.period }}, Start:
          {{
            new Date(course.start).toLocaleString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
            })
          }}, Ends:
          {{
            new Date(course.end).toLocaleString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
            })
          }}

          <v-chip
            class="ml-10"
            dark
            color="secondary"
            v-if="
              new Date(course.start).toLocaleDateString() ==
              new Date().toLocaleDateString()
            "
          >
            {{
              new Date(course.start).toLocaleString("en-US", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              })
            }}
            (Today)
          </v-chip>
          <v-chip class="ml-10" dark color="red" v-else>
            {{
              new Date(course.start).toLocaleString("en-US", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              })
            }}
            (Not Today)
          </v-chip>
        </h6>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <h5 class="mt-3">
        {{ teachers.length > 1 ? "Teachers:" : "Teacher" }}
        <div v-for="teacher in teachers" :key="teacher">
          <v-icon small> mdi-account </v-icon> {{ teacher }}
        </div>
      </h5>

      <template v-slot:extension>
        <v-tabs centered v-model="tab">
          <v-tabs-slider color="secondary"></v-tabs-slider>
          <v-tab>Content</v-tab>
          <v-tab v-if="allowed">Students</v-tab>
          <v-tab>Gradebook</v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <v-toolbar v-if="allowed" color="secondary" class="mt-0" dense height="30">
      <v-toolbar-title>Tools: </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items>
        <v-dialog v-if="tab != 2" v-model="counterdialog" max-width="360">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon small class="mx-1">
              <v-icon color="primary"> mdi-timer </v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="headline"> Timer </v-card-title>
            <v-card-text>
              <timer />
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-btn v-if="tab != 2" icon small class="mx-1">
          <a
            href="https://bouncyballs.org/"
            target="popup"
            onclick="window.open('https://bouncyballs.org/','popup','width=600,height=600'); return false;"
          >
            <v-icon> mdi-speaker-wireless </v-icon>
          </a>
        </v-btn>
        <v-card dense v-if="tab == 2" color="secondary lighten-1">
          <v-card-text>
            <v-row>
              <v-card
                v-for="gp in grading_periods"
                :key="gp.id"
                :dark="gp.id == grading_period.id"
                :color="gp.id == grading_period.id ? 'primary' : 'secondary lighten-1'"
                class="mx-2 px-1"
                dense
                @click="viewGradingPeriod(gp)"
                >{{ gp.name }}</v-card
              >
            </v-row>
          </v-card-text>
        </v-card>
        <!-- the followin card is for behavior chart
        currently tab==10 is the condition and since we dont have 10 tabs
        it will not be shown  -->
        <v-card
          v-if="tab == 10"
          :color="showPoints === true ? 'secondary lighten-1' : 'secondary'"
        >
          <v-btn icon small class="mx-1">
            <v-icon
              :color="showPoints === true ? 'green' : 'primary'"
              @click="
                showPoints === true ? (showPoints = false) : (showPoints = true)
              "
              >mdi-thumbs-up-down</v-icon
            >
          </v-btn>
          <v-dialog v-model="dialog" max-width="500px" scrollable>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small class="mx-1" v-bind="attrs" v-on="on">
                <v-icon v-if="showPoints" color="green">mdi-cog</v-icon>
              </v-btn>
            </template>
            <v-card dense>
              <v-card-title
                >Points Options <v-spacer />
                <v-icon @click="dialog = false">
                  mdi-close</v-icon
                ></v-card-title
              >
              <v-divider />
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="7" md="7">
                      <v-text-field
                        dense
                        v-model="newOption.text"
                        placeholder="Add new"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                      <v-text-field
                        dense
                        v-model="newOption.point"
                        number
                        placeholder="Point"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                      <v-div v-if="newOption.text && newOption.point">
                        <v-btn
                          v-if="newOption.point >= 0"
                          class="mb-n3"
                          x-small
                          color="green"
                          @click="addOption()"
                          >Add</v-btn
                        >
                        <v-btn
                          v-else
                          class="mb-n3"
                          x-small
                          color="red"
                          dark
                          @click="addOption()"
                          >Add</v-btn
                        >
                      </v-div>
                    </v-col>
                  </v-row>
                  <v-row v-for="(option, id) in behaviorOptions" :key="id">
                    <v-col cols="12" sm="7" md="7">
                      <v-text-field dense v-model="option.text"> </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                      <v-text-field dense v-model="option.point" number>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                      <v-icon
                        class="mb-n3"
                        v-if="option.point >= 0"
                        color="green"
                        >mdi-thumb-up</v-icon
                      >
                      <v-icon class="mb-n3" v-else color="red"
                        >mdi-thumb-down</v-icon
                      >
                    </v-col>
                    <v-col cols="12" sm="1" md="1">
                      <v-icon @click="removeOption(option.text)" class="mb-n3"
                        >mdi-trash-can-outline</v-icon
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-divider />
              <v-card-actions>
                <v-spacer />

                <v-btn small color="primary" @click="saveOptions()"
                  >Save changes</v-btn
                >
                <v-btn small color="primary" @click="dialog = false"
                  >close</v-btn
                >
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </v-toolbar-items>
    </v-toolbar>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <teachers-course-content v-if="allowed"/>
        <students-course-content v-else/>
      </v-tab-item>
      <v-tab-item v-if="allowed">
        <attendance
          class="mt-3"
          :showPoints="false"
          :behaviorOptions="behaviorOptions"
        ></attendance>
      </v-tab-item>
      <v-tab-item>
        <v-container fluid>
          <v-row>
            <k4-gradebook
              v-if="allowed && is_k4"
              :section_info="course"
              :grading_period="grading_period"
              :grading_periods="grading_periods"
            ></k4-gradebook>
            <gradebook
              v-if="allowed && !is_k4"
              class="mt-n3"
              :section_info="course"
              :grading_period="grading_period"
              :grading_periods="grading_periods"
            ></gradebook>
            <student-gradebook
              v-if="!allowed"
              class="mt-n3"
              :section_info="course"
            ></student-gradebook>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import TeachersCourseContent from "../components/CourseContentTeachers.vue";
import StudentsCourseContent from "../components/CourseContentStudents.vue";
import Attendance from "../components/Attendance";
import Gradebook from "../components/Gradebook";
import K4Gradebook from "../components/K4Gradebook";
import StudentGradebook from "../components/StudentGradebook";
import Timer from "../components/Timer";

export default {
  components: {
    TeachersCourseContent,
    StudentsCourseContent,
    Attendance,
    Gradebook,
    K4Gradebook,
    StudentGradebook,
    Timer,
  },
  data: () => ({
    counterdialog: false,
    dialog: false,
    showPoints: false,
    tab: null,
    zoomLink: "Zoom",
    newOption: {},
    behaviorOptions: [
      { text: "misbehave", point: -2 },
      { text: "talking", point: -4 },
      { text: "off task", point: -3 },
      { text: "responding", point: 4 },
      { text: "on task", point: 3 },
      { text: "behave", point: 1 },
    ],
    grading_periods: [],
    grading_period: {},
  }),
  computed: {
    allowed() {
      return this.$store.state.u.type != "Student";
    },
    teachers() {
      return this.$store.state.course.teachers.split(", ");
    },
    course() {
      return this.$store.state.course;
    },
    is_k4() {
      return this.$store.state.course.is_k4;
    }
  },
  methods: {
    viewGradingPeriod(gp) {
      this.grading_period = gp;
    },
    addOption() {
      this.behaviorOptions.push(this.newOption);
      this.newOption = {};
      this.saveOptions();
    },
    removeOption(option) {
      this.behaviorOptions = this.behaviorOptions.filter(
        (item) => item.text != option
      );
      this.saveOptions();
    },
    saveOptions() {
      this.$sisApi(
        "patch",
        `course-sections/${this.course.course_id}/${this.course.section}`,
        { behavior_options: this.behaviorOptions }
      );
    },
  },
  mounted() {
    this.$sisApi("get", "my-schedule/grading-periods")
      .then((response) => {
        this.grading_periods = response.data;
        this.grading_period = this.grading_periods.find(
          (gp) => new Date(gp.end_date) > new Date() // first match
        );
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>
